module.exports = "https://pearup-project-assets.s3.eu-central-1.amazonaws.com/scratch/assets/96bb35bb5da9e2a531633aeabae12a4b.png";